import React, { useEffect, useState } from "react";

const PagoNotificacion = () => {
  const [mensaje, setMensaje] = useState("Escuchando (solo demo, no es un webhook real)...");

  useEffect(() => {
    console.log("=== [PagoNotificacion] Página cargada ===");
    console.log(
      "[PagoNotificacion] ADVERTENCIA: esta página NUNCA será llamada automáticamente " +
        "por la pasarela, porque esa llamada es servidor-a-servidor y no pasa por el navegador."
    );
    setMensaje(
      "Esta ruta es solo para revisión manual. En producción necesitas un endpoint de servidor real."
    );
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h3>Pago Notificación (demo front-end)</h3>
      <p>{mensaje}</p>
    </div>
  );
};

export default PagoNotificacion;